import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of, Observable, switchMap } from 'rxjs';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';
import { CoordinationService } from '../../../coordination/shared/services/coordination/coordination.service';

export const ApplicationCoordinationStatusResolver = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
): Observable<boolean> => {
    const coordinationService = inject(CoordinationService);

    const router = inject(Router);

    const applicationId = route.paramMap.get('id');

    if (!applicationId) {
        return navigateToHome(router);
    }

    return coordinationService.getCoordinationStatus(applicationId).pipe(
        switchMap((applicationCoordinationStatus) => {
            if (!applicationCoordinationStatus) {
                return navigateToHome(router);
            }

            return of(true);
        }),
    );
};
